// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"7bd10d7f","238":"df2b37fe","239":"aba56329","396":"664461b1","455":"38923cee","977":"2c1e871f"}[chunkId] + ".chunk.js";
};